<template>
    <div id="questionnaire" class="page">
        <div class="header">
            <el-button type="primary" v-if="!isVote" @click.native="submitAnswer" :disabled="isSubmited">提交</el-button>
            <span v-if="!isVote" class="general-hint">
                注意：所有信息一经提交，不能再修改，请仔细填写核对，确保信息真实有效！
            </span>
            <el-button type="primary" v-if="isVote" @click.native="print()">打印</el-button>
            <el-button type="primary" v-if="isVote && voteTwoRecruitUser && voteTwoRecruitUser.recruitStatus != 3" @click.native="withdraw()">退报</el-button>
        </div>
        <div class="main-container" ref="print" id="print">
            <div v-if="!isVote" class="basic-info-container">
                <div v-if="isVote">
                    <span class="basic-info-item">
                        <span class="basic-info-item__label">序号：</span>
                        <span class="basic-info-item__value">{{recruitNo}}</span>
                    </span>
                </div>
                <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}姓名：</span>
                    <span class="basic-info-item__value">{{userName}}</span>
                </span>
                <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}性别：</span>
                    <span class="basic-info-item__value" v-if="gender">{{gender == 1 ? '男' : '女'}}</span>
                    <span class="basic-info-item__value" v-else>{{cardId | getGender}}</span>
                </span>
                <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}生日：</span>
                    <span class="basic-info-item__value" v-if="birthday">{{birthday}}</span>
                    <span class="basic-info-item__value" v-else>{{cardId | getBirthday}}</span>
                </span>
                <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}身份证/护照：</span>
                    <span class="basic-info-item__value">{{cardId}}</span>
                </span>
                <span class="basic-info-item">
                    <span class="basic-info-item__label">家长手机号：</span>
                    <span class="basic-info-item__value">{{mobile}}</span>
                </span>
            </div>
            <div v-if="!isVote" class="questionnaire-container">
                <div class="question-container">
                    <template v-for="(questionItem, questionIndex) in topicList">
                        <!--单选-->
                        <div :key="questionIndex" v-if="questionItem.topType === 1"
                             class="question-item quetion-item--single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">单选</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                         class="question-option-container">
                                        <div>
                                            <el-checkbox :disabled="isVote" :name="questionItem.id.toString()" @change="radioChangeHandler(questionItem, optionItem)" :true-label="1" :false-label="0" v-model="optionItem.isSelected">
                                                {{optionItem.optionTitle}}
                                            </el-checkbox>
                                        </div>
                                        <div v-if="optionItem.isHaveReason === 1" v-show="optionItem.isSelected === 1">
                                            <el-input
                                                v-model.trim="optionItem.optionAnswer"
                                                type="textarea"
                                                :rows="3"
                                                placeholder="请输入"
                                                :maxlength="500"
                                            >
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--多选填空-->
                        <div :key="questionIndex" v-if="questionItem.topType === 21"
                             class="question-item quetion-item--single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">多选填空</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                         class="question-option-container">
                                        <span style="color: red" v-if="optionItem.isHaveReason === 1">*</span>
                                        <template v-for="(part, partIndex) in optionItem.blankArray">
                                            <span v-if="!/{\d+?}/.test(part)">
                                                {{part}}
                                            </span>
                                            <input v-else :disabled="isVote" v-model.trim="optionItem.blankAnswerArray[partIndex]" type="text" class="blank" :maxlength="`${part.slice(1, part.length - 1)}`" :style="{width: `${20 * parseInt(part.slice(1, part.length - 1))}px`}" />
                                        </template>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--单选填空-->
                        <div :key="questionIndex" v-if="questionItem.topType === 14"
                             class="question-item quetion-item--single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    {{questionItem.topicTitle}}&nbsp;&nbsp;
                                    <el-tag type="primary">单项填空</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                         class="question-option-container">
                                        <span style="color: red" v-if="optionItem.isHaveReason === 1">*</span>
                                        <template v-for="(part, partIndex) in optionItem.blankArray">
                                                <span v-if="!/{\d+?}/.test(part)">
                                                    {{part}}
                                                </span>
                                            <input v-else :disabled="isVote" v-model.trim="optionItem.blankAnswerArray[partIndex]" type="text" class="blank" :maxlength="`${part.slice(1, part.length - 1)}`" :style="{width: `${20 * parseInt(part.slice(1, part.length - 1))}px`}" />
                                        </template>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--多选-->
                        <div :key="questionIndex" v-if="questionItem.topType === 2"
                             class="question-item quetion-item--multiple-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">多选</el-tag>
                                    <el-tag type="primary" v-if="questionItem.selectedMax !== 0">限选{{questionItem.selectedMax}}</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <div v-for="(optionItem, optionIndex) in questionItem.optionList"
                                         class="question-option-container">
                                        <div>
                                            <el-checkbox :disabled="isVote" :name="questionItem.id.toString()" :true-label="1" :false-label="0" v-model="optionItem.isSelected">
                                                {{optionItem.optionTitle}}
                                            </el-checkbox>
                                        </div>
                                        <div v-if="optionItem.isHaveReason === 1" v-show="optionItem.isSelected === 1">
                                            <el-input
                                                v-model.trim="optionItem.optionAnswer"
                                                type="textarea"
                                                :rows="3"
                                                placeholder="请输入"
                                                :maxlength="500"
                                            >
                                            </el-input>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--图片单选-->
                        <div :key="questionIndex" v-if="questionItem.topType === 3"
                             class="question-item quetion-item--pic-single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">单选</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <image-previewer tag="richtext" viewclass="question-pic" :images="questionItem.picList">
                                        <div class="question-option-container"
                                             v-for="(optionItem, optionIndex) in questionItem.optionList">
                                            <div class="question-pic"
                                                 :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                            <div class="question-pic-desc">
                                                <div>
                                                    <el-checkbox :disabled="isVote" :name="questionItem.id.toString()" @change="radioChangeHandler(questionItem, optionItem)" :true-label="1" :false-label="0" v-model="optionItem.isSelected">
                                                        {{optionItem.optionTitle}}
                                                    </el-checkbox>
                                                </div>
                                                <div v-if="optionItem.isHaveReason === 1" v-show="optionItem.isSelected === 1">
                                                    <el-input
                                                        v-model.trim="optionItem.optionAnswer"
                                                        type="textarea"
                                                        :rows="3"
                                                        placeholder="请输入"
                                                        :maxlength="500"
                                                    >
                                                    </el-input>
                                                </div>
                                            </div>
                                        </div>
                                    </image-previewer>
                                </div>
                            </div>
                        </div>
                        <!--图片多选-->
                        <div :key="questionIndex" v-if="questionItem.topType === 4"
                             class="question-item quetion-item--pic-multiple-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">多选</el-tag>
                                    <el-tag type="primary" v-if="questionItem.selectedMax !== 0">{{questionItem.selectedMax}}</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <image-previewer tag="richtext" viewclass="question-pic" :images="questionItem.picList">
                                        <div class="question-option-container"
                                             v-for="(optionItem, optionIndex) in questionItem.optionList">
                                            <div class="question-pic"
                                                 :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                            <div class="question-pic-desc">
                                                <div>
                                                    <el-checkbox :disabled="isVote" :name="questionItem.id.toString()" :true-label="1" :false-label="0" v-model="optionItem.isSelected">
                                                        {{optionItem.optionTitle}}
                                                    </el-checkbox>
                                                </div>
                                                <div v-if="optionItem.isHaveReason === 1" v-show="optionItem.isSelected === 1">
                                                    <el-input
                                                        v-model.trim="optionItem.optionAnswer"
                                                        type="textarea"
                                                        :rows="3"
                                                        placeholder="请输入"
                                                        :maxlength="500"
                                                    >
                                                    </el-input>
                                                </div>
                                            </div>
                                        </div>
                                    </image-previewer>
                                </div>
                            </div>
                        </div>

                        <!--问答题-->
                        <div :key="questionIndex" v-if="questionItem.topType === 5"
                             class="question-item quetion-item--qna">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">问答</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-input
                                        :disabled="isVote"
                                        type="textarea"
                                        :rows="3"
                                        :maxlength="500"
                                        placeholder="答题内容(1-500个字符)"
                                        v-model.trim="questionItem.topicAnswer">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <!--填空题-->
                        <div :key="questionIndex" v-if="questionItem.topType === 6"
                             class="question-item quetion-item--fill-blank">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    <template v-for="(part, partIndex) in questionItem.blankArray">
                                        <span v-if="!/{\d+?}/.test(part)">
                                            {{part}}
                                        </span>
                                        <input v-else :disabled="isVote" v-model.trim="questionItem.blankAnswerArray[partIndex]" type="text" class="blank" :maxlength="`${part.slice(1, part.length - 1)}`" :style="{width: `${20 * parseInt(part.slice(1, part.length - 1))}px`}" />
                                    </template>
                                    <el-tag type="primary">填空</el-tag>
                                </div>
                            </div>
                        </div>
                        <!--描述-->
                        <div :key="questionIndex" v-if="questionItem.topType === 7"
                             class="question-item quetion-item--fill-blank">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__body">
                                    {{questionItem.topicTitle}}
                                </div>
                            </div>
                        </div>

                        <!--分割线-->
                        <div :key="questionIndex" v-if="questionItem.topType === 8"
                             class="question-item quetion-item--divider">
                            <div class="question-item__left">
                            </div>
                            <div class="question-item__right">
                                <div class="divider"></div>
                            </div>
                        </div>
                        <!--地址-->
                        <div :key="questionIndex" v-if="questionItem.topType === 9"
                             class="question-item quetion-item--address">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">地址</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-cascader
                                        :disabled="isVote"
                                        size="large"
                                        :options="options"
                                        v-model="questionItem.addressArray">
                                    </el-cascader>
                                    <el-input placeholder="请输入街道小区门牌号" :disabled="isVote" type="text" v-model.trim="questionItem.detailAddress">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <!--单个图片上传-->
                        <div :key="questionIndex" v-if="questionItem.topType === 10"
                             class="question-item quetion-item--pic-single-uploader">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">单图上传</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <div class="pic-item" :style="{backgroundImage: `url(${picItem})`}" v-for="(picItem, picIndex) in questionItem.picList">
                                        <span class="delete-icon" @click="deletePic(questionItem, picIndex)"></span>
                                    </div>
                                    <uploader
                                        module="zhaoshengbaomingyoueryuan"
                                        pathPrefix="zhaoshengbaomingyoueryuan"
                                        moduleCode="20190308"
                                        :disabled="isVote"
                                        v-show="questionItem.picList.length === 0"
                                        v-model="questionItem.pics"
                                        :multiple="true"
                                        :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                        showMode="image"
                                        showResult="no"
                                        :successCallback="optionPicUploadSuccessHandler(questionItem)"
                                    >
                                    </uploader>
                                </div>
                            </div>
                        </div>

                        <!--多个图片上传-->
                        <div :key="questionIndex" v-if="questionItem.topType === 11"
                             class="question-item quetion-item--pic-multiple-uploader">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">多图上传</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <div class="pic-item" :style="{backgroundImage: `url(${picItem})`}" v-for="picItem in questionItem.picList">
                                        <span class="delete-icon" @click="deletePic(questionItem, picIndex)"></span>
                                    </div>
                                    <uploader
                                        module="zhaoshengbaomingyoueryuan"
                                        pathPrefix="zhaoshengbaomingyoueryuan"
                                        moduleCode="20190308"
                                        :disabled="isVote"
                                        v-model="questionItem.pics"
                                        :multiple="true"
                                        :extList="['jpeg', 'jpg', 'bmp', 'gif', 'png']"
                                        showMode="image"
                                        showResult="no"
                                        :successCallback="optionPicUploadSuccessHandler(questionItem)"
                                    >
                                    </uploader>
                                </div>
                            </div>
                        </div>

                        <!--评分题-->
                        <div :key="questionIndex" v-if="questionItem.topType === 12"
                             class="question-item quetion-item--multiple-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">评分题</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-rate :disabled="isVote" v-model="questionItem.topicAnswer"></el-rate>
                                </div>
                            </div>
                        </div>

                        <!--手机号-->
                        <div :key="questionIndex" v-if="questionItem.topType === 15"
                             class="question-item quetion-item--pic-single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">手机号</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-input placeholder="请输入手机号" @blur="inputBlurHandler(questionItem)" :disabled="isVote" type="text" v-model.trim="questionItem.topicAnswer">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <!--邮箱-->
                        <div :key="questionIndex" v-if="questionItem.topType === 16"
                             class="question-item quetion-item--pic-single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">邮箱</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-input placeholder="请输入邮箱" @blur="inputBlurHandler(questionItem)" :disabled="isVote" type="text" v-model.trim="questionItem.topicAnswer">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <!--身份证-->
                        <div :key="questionIndex" v-if="questionItem.topType === 17"
                             class="question-item quetion-item--pic-single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">身份证</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-input placeholder="请输入身份证" @blur="inputBlurHandler(questionItem)"  :disabled="isVote" type="text" v-model.trim="questionItem.topicAnswer">
                                    </el-input>
                                </div>
                            </div>
                        </div>

                        <!--日期-->
                        <div :key="questionIndex" v-if="questionItem.topType === 18"
                             class="question-item quetion-item--pic-single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">日期</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-date-picker
                                        :disabled="isVote"
                                        v-model="questionItem.topicAnswer"
                                        type="date"
                                        placeholder="请选择日期">
                                    </el-date-picker>
                                </div>
                            </div>
                        </div>

                        <!--时间-->
                        <div :key="questionIndex" v-if="questionItem.topType === 19"
                             class="question-item quetion-item--pic-single-choice">
                            <div class="question-item__left">
                                <el-tag type="primary">Q{{questionItem.topicSeq}}</el-tag>
                            </div>
                            <div class="question-item__right">
                                <div class="question-item__title">
                                    <span class="request-hint" v-if="questionItem.isHaveToDo === 0">*</span>
                                    {{questionItem.topicTitle}}
                                    <el-tag type="primary">时间</el-tag>
                                </div>
                                <div class="question-item__body">
                                    <el-time-select
                                        :disabled="isVote"
                                        v-model="questionItem.topicAnswer"
                                        placeholder="请选择时间"
                                        :picker-options="{
                                              start: '00:01',
                                              step: '00:01',
                                              end: '24:00'
                                            }"
                                    >
                                    </el-time-select>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>

            </div>

            <div v-else class="questionnaire-container questionnaire-container--detail">
                <div class="basic-info-container">
                    <div v-if="isVote">
                    <span class="basic-info-item">
                        <span class="basic-info-item__label">序号：</span>
                        <span class="basic-info-item__value">{{recruitNo}}</span>
                    </span>
                    </div>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}姓名：</span>
                    <span class="basic-info-item__value">{{userName}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}性别：</span>
                    <span class="basic-info-item__value" v-if="gender">{{gender == 1 ? '男' : '女'}}</span>
                    <span class="basic-info-item__value" v-else>{{cardId | getGender}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}生日：</span>
                    <span class="basic-info-item__value" v-if="birthday">{{birthday}}</span>
                    <span class="basic-info-item__value" v-else>{{cardId | getBirthday}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">{{schoolType == 1 ? '幼儿' : '学生'}}身份证/护照：</span>
                    <span class="basic-info-item__value">{{cardId}}</span>
                </span>
                    <span class="basic-info-item">
                    <span class="basic-info-item__label">家长手机号：</span>
                    <span class="basic-info-item__value">{{mobile}}</span>
                </span>
                </div>
                <div class="questionnaire-content">
                    <template v-for="(questionItem, questionIndex) in topicList">
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 1"
                            class="question-item quetion-item--single-choice"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                    {{optionItem.optionTitle}}<span v-if="optionItem.isHaveReason === 1">（{{optionItem.optionAnswer}}）</span>
                                </div>
                            </div>

                        </div>
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 2"
                            class="question-item quetion-item--multiple-choice"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                            <div class="question-item__choice" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                <div class="answers">
                                    <div>
                                        {{optionItem.optionTitle}}
                                        <span v-if="optionItem.isHaveReason === 1" class="question-item__answer-area">
                                        （{{optionItem.optionAnswer}}）
                                    </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 3"
                            class="question-item quetion-item--pic-multiple-choice"
                        >
                            <div class="question-item__title">{{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                            <div class="answers">
                                <image-previewer tag="richtext" viewclass="question-item__choice-pic" :images="questionItem.picList">
                                    <div class="question-item__choice" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                        <div class="question-item__choice-pic" :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                        <img class="print-img" :src="optionItem.optionPicUrl" />
                                        <div>{{optionItem.optionTitle}}</div>
                                        <div v-if="optionItem.isHaveReason === 1 && optionItem.isSelected === 1" class="question-item__answer-area">
                                            {{optionItem.optionAnswer}}
                                        </div>
                                    </div>
                                </image-previewer>
                            </div>

                        </div>
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 4"
                            class="question-item quetion-item--pic-multiple-choice"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                            <div class="answers">
                                <image-previewer tag="richtext" viewclass="question-item__choice-pic" :images="questionItem.picList">
                                    <div class="question-item__choice" v-if="optionItem.isSelected === 1" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                        <div class="question-item__choice-pic" :style="{backgroundImage: `url(${optionItem.optionPicUrl})`}"></div>
                                        <img class="print-img" :src="optionItem.optionPicUrl" />
                                        <div>
                                            {{optionItem.optionTitle}}
                                        </div>
                                        <div v-if="optionItem.isHaveReason === 1" class="question-item__answer-area">
                                            （{{optionItem.optionAnswer}}）
                                        </div>
                                    </div>
                                </image-previewer>
                            </div>

                        </div>
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 5"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer}}
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 6"
                            class="question-item question-item--fill"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、<span v-html="questionItem.topicAnswer ? parseFillblank(questionItem.topicAnswer) : parseFillblankInput(questionItem.topicTitle)"></span>
                            </div>
                        </div>


                        <div
                            :key="questionIndex" v-if="questionItem.topType === 14"
                            class="question-item quetion-item--single-fill"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                            <div class="answers">
                                <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                    <span v-if="optionItem.isSelected === 1" v-html="parseFillblank(optionItem.optionAnswer)"></span>
                                    <span  v-else v-html="parseFillblankInput(optionItem.optionTitle)"></span>
                                </div>
                            </div>

                        </div>
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 21"
                            class="question-item quetion-item--multiple-fill"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                            </div>
                            <div class="answers">
                                <div class="question-item__choice" v-for="(optionItem, optionIndex) in questionItem.optionList">
                                    <span v-if="optionItem.isSelected === 1" v-html="parseFillblank(optionItem.optionAnswer)"></span>
                                    <span  v-else v-html="parseFillblankInput(optionItem.optionTitle)"></span>
                                </div>
                            </div>

                        </div>
                        <div
                            :key="questionIndex" v-if="questionItem.topType === 12"
                            class="question-item quetion-item--rate"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    <el-rate :value="questionItem.topicAnswer"></el-rate>
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 9"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer}}
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 7"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 10"
                            class="question-item question-item--qna quetion-item--pic-single-uploader"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                            <div class="question-item__answer-area">
                                <!--{{questionItem.topicAnswer}}-->
                                <template v-if="questionItem.topicAnswer">
                                    <image-previewer tag="richtext" viewclass="pic-item" :images="questionItem.picList">
                                        <div class="pic-item" v-for="picItem in JSON.parse(questionItem.topicAnswer)" :style="{backgroundImage: `url(${picItem})`}"></div>
                                    </image-previewer>
                                </template>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 11"
                            class="question-item question-item--qna quetion-item--pic-multiple-uploader"
                        >
                            <div class="question-item__title">
                                {{questionItem.topicSeq}}、{{questionItem.topicTitle}}&nbsp;&nbsp;
                            </div>
                            <div class="question-item__answer-area">
                                <template v-if="questionItem.topicAnswer">
                                    <image-previewer tag="richtext" viewclass="pic-item" :images="questionItem.picList">
                                        <div class="pic-item" v-for="picItem in JSON.parse(questionItem.topicAnswer)" :style="{backgroundImage: `url(${picItem})`}"></div>
                                    </image-previewer>
                                </template>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 8"
                            class="question-item question-item--qna"
                        >
                            <div class="divider"></div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 15"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer}}
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 16"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer}}
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 17"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer}}
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 18"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer | toDate}}
                                </div>
                            </div>
                        </div>

                        <div
                            :key="questionIndex" v-if="questionItem.topType === 19"
                            class="question-item question-item--qna"
                        >
                            <div class="question-item__title">
                                <div class="info-label">
                                    {{questionItem.topicSeq}}、{{questionItem.topicTitle}}
                                </div>
                                <div class="question-item__choice info-value">
                                    {{questionItem.topicAnswer}}
                                </div>
                            </div>
                        </div>
                    </template>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Uploader from '@/components/Uploader/WebUploader';

    import ImagePreviewer from '@/components/ImagePreviewer/ImagePreviewer.vue';
    import { regionData, CodeToText } from '@/utils/element-china-area-data'
    import baseMixin from '@/mixins/baseMixin';
    import {
        delVoteTwoRecruitUserCommon
    } from '@/api/notice';
    import {mapMutations} from 'vuex';
    import {mapGetters} from 'vuex';
    import {getCurrentSchoolTimeBySchoolId} from '@/api/common';
     import {queryById} from '@/api/primary/outer';
    import {getVoteByRecruitUser, addVoteTwoRecruitUserSelectedList} from '@/api/outer';
    import moment from 'moment';

    export default {
        name: "questionnaire",
        components: {
            ImagePreviewer,
            Uploader
        },
        mixins: [baseMixin],
        data: function () {
            return {
                schoolType: this.$route.query.schoolType,

                isSubmited: false,
                test: 1,
                userName: this.$route.query.userName,
                mobile: this.$route.query.mobile,
                cardId: this.$route.query.cardId,
                gender: this.$route.query.gender,
                birthday: this.$route.query.birthday,
                schoolId: this.$route.query.schoolId,

                isVote: false,
                options: regionData,
                basePath: global.BasePath,
                showNav: false,
                userId: this.$route.query.userId,
                expriyDate: '',
                id: this.$route.query.id,
                voteTitle: '',
                voteDesc: '',
                sendUserType: null,
                anonymous: null,
                topicList: [],
                voteStatus: null,
                isShowResult: null,
                maxVoteCount: 0,
                stuDepartJson: '{}',
                thScopeJson: '{}',
                recruitNo: '',
                voteTwoRecruitUser: {},
                areaCode:''
            }
        },
         computed: {
            ...mapGetters(['schoolInfo'])
        },
        created() {
             queryById({
                    id: this.schoolId
                })
                    .then(res => res.data)
                    .then(data => {
                        this.areaCode= data.data.areaCode;
                         getCurrentSchoolTimeBySchoolId({
                schoolId: this.$route.query.schoolId,
            })
                .then(res => res.data)
                .then(data => {
                    this.SET_SELECTED_SCHOOLYEAR(data.schoolYear);
                    getVoteByRecruitUser({
                        token: sessionStorage.getItem('outerToken')
                    })
                        .then(res => res.data)
                        .then(data => {
                            const pageData = data.data;
                            this.voteTitle = pageData.voteTitle;
                            this.voteDesc = pageData.voteDesc;
                            this.sendUserType = pageData.sendUserType;
                            this.expriyDate = pageData.expriyDate;
                            this.anonymous = pageData.anonymous;
                            this.isVote = pageData.isVote !== 0;
                            this.recruitNo = pageData.recruitNo;
                            this.voteTwoRecruitUser = pageData.voteTwoRecruitUser;

                            pageData.topicList.forEach(item => {
                                item.optionIdList = [];
                                if(!this.isVote) {
                                    item.topicAnswer = '';
                                }

                                if(item.topType === 4 || item.topType === 3) {
                                    item.picList = item.optionList.map(item => ({src: item.optionPicUrl}));
                                }
                                if(item.topType === 14 || item.topType === 21) {
                                    item.optionList.forEach(optionItem => {
                                        optionItem.blankArray = optionItem.optionTitle.split(/({\d+?})/g).filter(item => item !== '');
                                        optionItem.blankAnswerArray = [...optionItem.blankArray].map(item => /{\d+?}/g.test(item) ? '' : item);
                                    })
                                }
                                if (item.topType === 6) {
                                    item.blankArray = item.topicTitle.split(/({\d+?})/g).filter(item => item !== '');
                                    item.blankAnswerArray = [...item.blankArray].map(item => /{\d+?}/g.test(item) ? '' : item);
                                }
                                if (item.topType === 10 || item.topType === 11) {
                                    item.picList = [];
                                }
                                if (item.topType === 18) {
                                    item.topicAnswer = item.topicAnswer !== '' ? moment(item.topicAnswer).format('YYYY-MM-DD') : '';
                                }
                                if (item.topType === 9) {
                                    item.addressArray = ['320000', '320100',this.areaCode|| '320102'];
                                    item.detailAddress = '';
                                }

                            });

                            this.topicList = pageData.topicList;
                            this.stuDepartJson = pageData.stuDepartJson;
                            this.thScopeJson = pageData.thScopeJson;
                            this.voteStatus = pageData.voteStatus;
                            this.isShowResult = pageData.isShowResult;
                            this.maxVoteCount = pageData.maxVoteCount;
                        })
                        .catch((error) => {
                            if(error.code === -1) {
                                this.$router.push({
                                    path: 'outerNotice',
                                    query: {
                                        id: sessionStorage.getItem('outerNoticeId')
                                    }
                                })
                            }
                        });
                });
                       
                    })
        },
        filters: {
            getBirthday(value) {
                return `${value.substring(6, 10)}年${value.substring(10, 12)}月${value.substring(12, 14)}日`
            },
            getGender(value) {
                return Number.parseInt(value.substring(16, 17)) % 2 === 1 ? '男' : '女';
            }
        },
        methods: {
            ...mapMutations(['SET_SELECTED_SCHOOLYEAR']),
            withdraw() {
                return this.$confirm(`退报将删除在本${this.schoolType == 1 ? '园' : '校'}报名数据，请确认操作`)
                    .then(_ => {
                        delVoteTwoRecruitUserCommon([{
                            noticeId: this.voteTwoRecruitUser.noticeId,
                            voteId: this.voteTwoRecruitUser.voteId,
                            id: this.voteTwoRecruitUser.id
                        }])
                            .then(res => res.data)
                            .then(data => {
                                if(data.result) {
                                    this.$message.success('已退报');
                                    this.$router.back();
                                } else {
                                    this.$message.error(data.msg);
                                }
                            })
                    })
                    .catch(_ => {
                    });
            },
            print() {
                this.$print(this.$refs.print)
            },
            beforeUploadHandler(file) {
                const ext = file.name.slice(file.name.lastIndexOf('.') + 1).toLowerCase();
                const extList = ['jpg', 'png', 'bmp', 'jpeg'];
                if(extList.indexOf(ext) === -1) {
                    this.$message({
                        message: `封面后缀名必须是[${extList.join(', ')}]`,
                        type: 'error'
                    });
                    return false;
                }
            },
            parseFillblank(title) {
                return title.replace(/{(.*?)}/g, (_, content) => {
                    return `<span style="border-bottom: 1px solid #000;">${content || '_____'}</span>`;
                })
            },
            parseFillblankInput(title) {
                return title.replace(/{(\d+?)}/g, function(_, num) {
                    return `<input type="text" style="border: 0;border-bottom: 1px solid #000; background: transparent;" disabled class="blank" maxlength="${num}" style="width: ${num * 20}px" />`
                });
            },
            deletePic(questionItem, picIndex) {
                questionItem.picList.splice(picIndex, 1);
            },
            // parseFillblank(title) {
            //     return title.replace(/{(\d+?)}/g, function (_, num) {
            //         return `<input type="text" class="blank" maxlength="${num}" style="width: ${num * 20}px" />`
            //     });
            // },
            radioChangeHandler(questionItem, optionItem) {
                questionItem.optionList.forEach(item => {
                    if (item.id !== optionItem.id) {
                        item.isSelected = 0;
                    }
                })
            },
            optionPicUploadSuccessHandler(quesionItem) {
                return (data) => {
                    quesionItem.picList.push(data.fileUrl);
                }
            },
            inputBlurHandler(topicItem) {
                const validObj = this.checkFunc(topicItem);
                if (!validObj.valid) {
                    this.$message.error(validObj.errorText);
                }
            },
            checkFunc(topicItem) {
                let errorText = '';
                let valid = true;
                const selectedOptions = topicItem.optionList.filter(item => item.isSelected === 1);
                if(topicItem.isHaveToDo === 0 && topicItem.topType !== 7 && topicItem.topType !== 8) {
                    if (topicItem.topType === 6) {
                        if(topicItem.blankAnswerArray.some(item => item === '')) {
                            errorText = `第${topicItem.topicSeq}题请正确填空！`;
                            valid = false;
                        }
                    } else if (topicItem.topType === 21 || topicItem.topType === 14) {
                        if (topicItem.optionList.some(optionItem => optionItem.isHaveReason === 1 && optionItem.blankAnswerArray.some(item => item === ''))) {
                            errorText = `第${topicItem.topicSeq}题请正确填空！`;
                            valid = false;
                        }
                    } else if (topicItem.topType === 10 || topicItem.topType === 11) {
                        if (topicItem.picList.length === 0) {
                            errorText = `第${topicItem.topicSeq}题请上传图片！`;
                            valid = false;
                        }
                    } else if (topicItem.topType === 15) {
                        if(!/^1[345789]\d{9}$/.test(topicItem.topicAnswer)) {
                            errorText = `第${topicItem.topicSeq}题手机号格式不正确！`;
                            valid = false;
                        }

                    } else if (topicItem.topType === 16 ) {
                        if(!/^(\w)+(\.\w+)*@(\w)+((\.\w+)+)$/.test(topicItem.topicAnswer)) {
                            errorText = `第${topicItem.topicSeq}题邮箱格式不正确！`;
                            valid = false;
                        }
                    } else if (topicItem.topType === 17) {
                        if(!/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(topicItem.topicAnswer)) {
                            errorText = `第${topicItem.topicSeq}题身份证格式不正确！`;
                            valid = false;
                        }
                    } else if (topicItem.topType === 9) {
                        if (topicItem.addressArray.length === 0 || topicItem.detailAddress === '') {
                            errorText = `第${topicItem.topicSeq}题请正确填写地址！`;
                            valid = false;
                        }
                    } else if (selectedOptions.length === 0 && topicItem.topicAnswer === '') {
                        errorText = `第${topicItem.topicSeq}题尚未回答！`;
                        valid = false;
                    }
                }
                if(topicItem.topType === 2 || topicItem.topType === 4) {
                    if(topicItem.selectedMax !== 0 && selectedOptions.length > topicItem.selectedMax) {
                        errorText = `第${topicItem.topicSeq}题超过限选数！`;
                        valid = false;
                    }
                }
                return {
                    valid,
                    errorText
                };
            },
            submitAnswer() {
                let isValid = true;
                let errorText = '';
                const voteTwoUserSelectedList = [];
                this.topicList.forEach(topicItem => {
                    if(isValid) {
                        const selectedOptions = topicItem.optionList.filter(item => item.isSelected === 1);
                        const validObj = this.checkFunc(topicItem);
                        errorText = validObj.errorText;
                        isValid = validObj.valid;

                        let answerObj = null;
                        switch (topicItem.topType) {
                            case 1:
                            case 2:
                            case 3:
                            case 4:
                                selectedOptions.forEach(option => {
                                    answerObj = {
                                        optionAnswer: option.optionAnswer || '',
                                        optionId: option.id,
                                        topicAnswer: '',
                                        topicId: topicItem.id,
                                        userId: this.userId,
                                        voteId: this.id,
                                    };
                                    voteTwoUserSelectedList.push(answerObj);
                                });
                                break;
                            case 5:
                            case 12:
                            case 15:
                            case 16:
                            case 17:
                            case 19:
                                answerObj = {
                                    optionAnswer: '',
                                    optionId: '',
                                    topicAnswer: topicItem.topicAnswer,
                                    topicId: topicItem.id,
                                    userId: this.userId,
                                    voteId: this.id
                                };
                                voteTwoUserSelectedList.push(answerObj);
                                break;
                            case 18:
                                answerObj = {
                                    optionAnswer: '',
                                    optionId: '',
                                    topicAnswer: moment(topicItem.topicAnswer).format('YYYY-MM-DD'),
                                    topicId: topicItem.id,
                                    userId: this.userId,
                                    voteId: this.id
                                };
                                voteTwoUserSelectedList.push(answerObj);
                                break;
                            case 6:
                                const topicAnswer = topicItem.blankArray.map((item, index) => {
                                    return /{\d+?}/.test(item) ? `{${topicItem.blankAnswerArray[index]}}` : item;
                                }).join('');
                                answerObj = {
                                    optionAnswer: '',
                                    optionId: '',
                                    topicAnswer,
                                    topicId: topicItem.id,
                                    userId: this.userId,
                                    voteId: this.id,
                                };
                                voteTwoUserSelectedList.push(answerObj);
                                break;
                            case 9:
                                answerObj = {
                                    optionAnswer: '',
                                    optionId: '',
                                    topicAnswer: `${topicItem.addressArray.map(item => CodeToText[item]).join(' ')} ${topicItem.detailAddress}`,
                                    topicId: topicItem.id,
                                    userId: this.userId,
                                    voteId: this.id,
                                };
                                voteTwoUserSelectedList.push(answerObj);
                                break;
                            case 10:
                            case 11:
                                answerObj = {
                                    optionAnswer: '',
                                    optionId: '',
                                    topicAnswer: topicItem.picList,
                                    topicId: topicItem.id,
                                    userId: this.userId,
                                    voteId: this.id,
                                };
                                voteTwoUserSelectedList.push(answerObj);
                                break;
                            case 14:
                            case 21:
                                topicItem.optionList.forEach(option => {
                                    const optionAnswer = option.blankArray.map((item, index) => {
                                        return /{\d+?}/.test(item) ? `{${option.blankAnswerArray[index]}}` : item;
                                    }).join('');
                                    answerObj = {
                                        optionAnswer,
                                        optionId: option.id,
                                        topicAnswer: '',
                                        topicId: topicItem.id,
                                        userId: this.userId,
                                        voteId: this.id,
                                    };
                                    voteTwoUserSelectedList.push(answerObj);
                                });
                                break;
                        }
                    }
                });
                if (!isValid) {
                    this.$message.error(errorText);
                } else {
                    console.log(voteTwoUserSelectedList);
                    this.$confirm('请谨慎填写，提交后不能修改。 是否提交？', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                    }).then(() => {
                        this.isSubmited = true;
                        addVoteTwoRecruitUserSelectedList({
                            token: sessionStorage.getItem('outerToken'),
                            voteTwoUserSelectedList: JSON.stringify(voteTwoUserSelectedList)
                        })
                            .then(res => res.data)
                            .then(data => {
                                const _this = this;
                                if(data.result) {
                                    this.$message({
                                        message: '提交成功',
                                        type: 'success',
                                        duration: 3000,
                                        onClose: function () {
                                            window.location.reload(true);
                                        }
                                    });
                                } else {
                                    this.$message({
                                        message: data.msg,
                                        type: 'error',
                                        duration: 3000
                                    });
                                }
                            })
                            .catch((error) => {
                                if(error.code === -1) {
                                    this.$router.push({
                                        path: 'outerNotice',
                                        query: {
                                            id: sessionStorage.getItem('outerNoticeId'),
                                            schoolId: this.schoolId,
                                        }
                                    })
                                }
                            });
                    }).catch(() => {
                    });
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../styles/mixin";

    @include globalstyle;
    .page {
        padding: 20px;
    }
    .info-label {
        @include middleIB;
        min-width: 115px;
    }
    .info-value {
        @include middleIB;
        color:#000;
    }
    .general-hint {
        color:#ff0000;
    }
    .main-container {
        color: #717171;
        width: 1310px;
        @include clearfix;
        margin: 10px auto;
        background-color: #fff;
    }
    .header {
        width: 1310px;
        margin: 10px auto;
        padding-left: 10px;
        box-sizing: border-box;
    }


    .questionnaire-container--detail {
        padding: 20px 60px;
        .question-item {
            margin-bottom: 20px;
        }
        .question-item {
            .question-item__title {
                color: #565656;
                font-size: 16px;
                font-weight: 700;
                margin-left: -26px;
            }
        }
    }

    .questionnaire-container {
        margin-left: 10px;
        border: 1px solid #DBDBDB;
        width: 1090px;
        float: left;
        box-sizing: border-box;

        input[type=text], textarea {
            &:focus {
                background: #FDF9CD;
            }
        }

        .questionnaire-title {
            padding: 5px 50px;

            input, textarea {
                width: 100%;
                height: 100%;
                text-align: center;
                font-size: 20px;
                border: 0;
                resize: none;
            }
        }

        .address-book-container {
            width: 200px;
            display: inline-block;
            vertical-align: middle;
        }

        .questionnaire-title {
            font-size: 20px;
            height: 56px;
            text-align: center;
            line-height: 56px;
        }

        .questionnaire-desc {
            height: 90px;
            font-size: 18px;
        }

        .operation-icon {
            display: none;
            /*display: inline-block;*/
            vertical-align: middle;
            width: 20px;
            height: 20px;
            background-image: url(../../../assets/images/wjsj_toolico_off.png);
            background-repeat: no-repeat;
            cursor: pointer;
        }

        .question-container {
            color: #000;
            padding: 5px 0;

            .question-item__body {
                margin-top: 10px;
            }

            .question-item {
                @include clearfix;
                .question-item__title {
                    clear: both;
                }
                padding: 10px 0;
                border-top: 1px solid #DBDBDB;

                &:hover {
                    .add-choice-icon, .batch-add-choice-icon, .up-icon, .down-icon, .question-delete-icon {
                        display: inline-block;
                    }
                }

                .question-item__left {
                    text-align: center;
                    width: 50px;
                    float: left;

                    .question-operation {
                        margin: 10px 0;

                        li {
                            margin-bottom: 5px;
                            display: block;
                            text-align: center;

                            &:last-child {
                                margin: 0;
                            }

                            .operation-icon {
                                &:hover {
                                    background-image: url(../../../assets/images/wjsj_toolico.png);
                                }
                            }

                            .up-icon {
                                background-position: -23px -513px;
                            }

                            .down-icon {
                                background-position: -23px -538px;
                            }

                            .question-delete-icon {
                                background-position: -21px -180px;
                            }
                        }
                    }
                }

                .question-item__right {
                    float: left;
                    width: 1020px;
                    box-sizing: border-box;
                    padding: 0 10px;

                    .question-item__title {
                        font-size: 14px;

                        input {
                            width: 72%;
                        }
                    }

                    .question-choice-options {
                        height: 26px;
                    }

                    input, textarea {
                        width: 100%;
                        height: 100%;
                        font-size: 14px;
                        border: 0;
                        resize: none;
                        margin-bottom: 5px;

                        &:focus {
                            background: #FDF9CD;
                        }
                    }

                    .option-del-icon {
                        margin-left: 5px;
                        background-position: -122px -241px;

                        &.option-del-icon--show {
                            display: inline-block !important;
                        }
                    }

                    .add-choice-icon {
                        margin-left: 20px;
                        background-position: -20px -200px;
                    }

                    .batch-add-choice-icon {
                        margin-left: 10px;
                        background-position: -20px -220px;
                    }

                }
            }

        }

        .question-item {
            @include clearfix;
            & > * {
                margin: 5px 0;
            }
            .question-item__type {
                font-size: 12px;
            }
            .question-item__choice-pic {
                @include cover-bg;
                @include wh(150px, 150px);
                margin-bottom: 5px;
            }
        }
        .quetion-item--pic-multiple-choice, .quetion-item--pic-multiple-choice {
            .question-item__choice {
                float: left;
                margin-right: 10px;
            }
        }
        .quetion-item--pic-single-choice,
        .quetion-item--pic-multiple-choice,
        .quetion-item--pic-single-uploader,
        .quetion-item--pic-multiple-uploader {
            .question-option-container {
                width: 160px;
                float: left;
                border: 1px solid #ccc;
                margin-right: 10px;
                margin-bottom: 10px;
                padding: 5px;

                .question-pic {
                    width: 160px;
                    height: 160px;
                    display: block;
                    margin-bottom: 5px;
                    @include cover-bg;
                }

                .question-pic-desc {
                    span {
                        @include middleIB;
                        width: 80%;
                    }

                    input {
                        width: 80% !important;
                    }
                }
            }

            .upload-hint {
                width: 160px;
                height: 160px;
                float: left;
                border: 1px solid #ccc;
                margin-right: 10px;
                margin-bottom: 10px;
                background: url(../../../assets/images/picinput.png) no-repeat;
                background-position: center center;
                cursor: pointer;
            }
        }
    }
    input.blank {
        border-width: 0;
        border-bottom:1px solid #000 !important;
    }

    .dialog-button-container {
        margin-top: 10px;
        text-align: right;
    }
    .question-option-container {
        margin-top: 10px;
    }
    .divider {
        border: 1px solid #999;
    }
    .pic-item {
        @include cover-bg;
        @include wh(160px, 160px);
        float: left;
        margin: 0 10px 10px 0;
        position: relative;
        .delete-icon {
            cursor: pointer;
            background-image: url(../../../assets/images/wxcep_phone_close.png);
            z-index: 3000;
            position: absolute;
            right: 0;
            top: 0;
            @include wh(30px, 30px);
        }
    }
    .request-hint {
        color: red;
    }
    .questionnaire-container--detail {
        margin-top: 10px;
        .basic-info-container {
            margin-left: 0;
        }
    }

    .basic-info-container {
        margin-left: 10px;
        width: 1090px;
        float: left;
        box-sizing: border-box;
        padding: 10px 0;
        font-weight: bold;
        .basic-info-item {
            @include middleIB;
            margin-bottom: 5px;
            width: 45%;
            & > *{
                @include middleIB;
            }
            .basic-info-item__label {
                width: 30%;
                text-align: left;
            }
        }
    }
    .recruit-no {
        position: absolute;
        top: 70px;
        left: 30px;
    }
    .print-img {
        display: none;
    }
    @media print {
        * {
            -webkit-print-color-adjust: exact;
        }
        .info-label, .info-value {
            display: block !important;
        }
        .question-item {
            margin-bottom: 20px !important;
        }
        .question-item__choice-pic {
            display: none !important;
        }
        .print-img {
            width: 150px !important;
            height:150px !important;
            display: block !important;
            margin-bottom: 5px !important;
        }
        .questionnaire-content {
            width: 1024px !important;
        }
        .question-item__choice {
            float: none !important;
        }
        .quetion-item--pic-multiple-choice {
            .question-item__choice {
                float: left !important;
                margin-right: 10px !important;
            }
        }
        .questionnaire-container .question-item .question-item__title {
            font-size: 16px !important;
            font-weight: 700 !important;
            margin: 5px 0 5px -26px !important;
        }
        .questionnaire-container {
            margin-right: 10px!important;
            width: 80% !important;
        }
        .divider {
            width: 90% !important;

        }
        .question-item__title {
            @include clearfix;
            & > * {
                float: left !important;
            }
        }
        .question-item--fill {
            .question-item__title {
                & > * {
                    float: none !important;
                }
            }

        }
        .questionnaire-container .question-item > * {
            margin: 5px 0 !important;
        }
        .basic-info-container {
            margin-left: 0 !important;
        }

        .question-item__title, .question-item__answer-area {
            display: inline-block !important;
        }
        .quetion-item--pic-single-uploader, .quetion-item--pic-multiple-uploader {
            .question-item__title, .question-item__answer-area {
                display: block !important;
                float: none !important;
            }

        }
    }
</style>
<style lang="scss">
    @import "../../../styles/mixin";

    #questionnaire {
        .address-box-item {
            line-height: 36px;
        }
        .el-checkbox, .el-checkbox__input {
            white-space: normal !important;
        }
        div {
            user-select: none;
            -webkit-user-select: none;
            -webkit-tap-highlight-color: transparent; /* 防止ios 出现点击div 出现选中效果*/
        }
        input{
            outline:none;
            -webkit-tap-highlight-color:rgba(0,0,0,0);
        }
        .el-checkbox, .el-checkbox__input {
            white-space: normal !important;
        }
        .img-upload {
            width: 80px;
            height: 80px;
            float: left;
            border: 1px solid #ccc;
            margin-right: 10px;
            margin-bottom: 10px;
            background: url(../../../assets/images/picinput.png) no-repeat center center;
            cursor: pointer;
        }
    }


</style>



// WEBPACK FOOTER //
// src/views/kindergarten/outer/OuterQuestionnaire.vue